import { ChangeDetectionStrategy, Component, Inject, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UoM } from '@jms/model';
import { CODE_PICKER_SERVICE } from '@jms/ui/ui.code.picker.pro';
import { PickerFetch } from '@jms/ui/ui.core.pickers/src/components';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import { CodePickerService } from '@jms/ui/ui.standalone.services/code.picker.service';
import { Observable, of } from 'rxjs';


@Component({
  selector: 'uom-picker',
  templateUrl: './uom.picker.component.html',
  styleUrls: ['./uom.picker.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: UoMPickerComponent, multi: true },
    CodePickerService
  ],
  standalone: false
})
export class UoMPickerComponent extends PickerBaseComponent implements OnInit, OnChanges {

  @Input() public data: UoM[];
  @Input() public placeholder = '<UoM>';
  // @Input() public appendTo;
  @Input() public multiple = false;

  public data$: Observable<UoM[]>;

  constructor(
    injector: Injector,
    @Inject(CODE_PICKER_SERVICE) private codeService: CodePickerService,
  ) {
    super(injector);
  }

  public async ngOnInit() { }

  public async ngOnChanges(changes: SimpleChanges) {

    if (changes?.fetch) {

      this.data$ = this.fetch === PickerFetch.Automatic
        ? this.codeService.loadUoMs()
        : of(this.data);

    }
  }

}
